(() => {
  if (window.storeProductOptionsReady) return;
  window.storeProductOptionsReady = true;

  const initialise = root => {
    if (root.dataset.optionsReady) return;
    const options = root.querySelector('[data-product-options]');
    const selectors = [...root.querySelectorAll('[data-product-option]')];
    const fallback = root.querySelector('[data-product-variant-fallback]');
    const fallbackSelect = fallback?.querySelector('select');
    const variantInput = root.querySelector('[data-product-variant-id]');
    const submit = root.querySelector('[data-product-submit]');
    const status = root.querySelector('[data-product-status]');
    const state = root.querySelector('[data-product-variant-state]');
    if (!options || !fallbackSelect || !variantInput || !submit || !status || !state) return;

    root.dataset.optionsReady = 'true';
    let requestNumber = 0;
    let controller;
    const showStatus = (message, error = false) => {
      status.textContent = message;
      status.hidden = !message;
      status.dataset.error = String(error);
    };
    const applyState = nextState => {
      const id = nextState.dataset.variantId;
      const available = Boolean(id) && nextState.dataset.available === 'true';
      variantInput.value = id || '';
      variantInput.disabled = !available;
      submit.disabled = !available;
      submit.textContent = available ? submit.dataset.addLabel : id ? status.dataset.soldOutLabel : status.dataset.unavailableLabel;
      showStatus(available ? '' : id ? status.dataset.soldOutLabel : status.dataset.unavailableLabel);
      return id;
    };
    fallbackSelect.disabled = true;
    fallback.hidden = true;
    options.hidden = false;
    applyState(state);

    variantInput.form.addEventListener('submit', event => {
      if (submit.disabled || variantInput.disabled || !variantInput.value) event.preventDefault();
    });

    options.addEventListener('change', async event => {
      if (!event.target.matches('[data-product-option]')) return;
      controller?.abort();
      controller = new AbortController();
      const currentRequest = ++requestNumber;
      const values = selectors.map(select => select.value).join(',');
      const url = new URL(root.dataset.productUrl, window.location.origin);
      const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', values);
      submit.disabled = true;
      variantInput.disabled = true;
      options.setAttribute('aria-busy', 'true');
      showStatus(status.dataset.loadingLabel);

      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Selection response unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (currentRequest !== requestNumber) return;
        const nextRoot = [...html.querySelectorAll('[data-product-root]')].find(element => element.dataset.sectionId === root.dataset.sectionId);
        const nextState = nextRoot?.querySelector('[data-product-variant-state]');
        const nextPrice = nextRoot?.querySelector('[data-variant-price]');
        if (!nextState || !nextPrice) throw new Error('Selection response incomplete');
        const nextSelectors = [...nextRoot.querySelectorAll('[data-product-option]')];
        if (nextSelectors.length !== selectors.length || nextSelectors.some((select, index) => select.value !== selectors[index].value)) throw new Error('Selection response mismatch');

        root.querySelector('[data-variant-price]').textContent = nextPrice.textContent;
        const unitPrice = root.querySelector('[data-variant-unit-price]');
        const nextUnitPrice = nextRoot.querySelector('[data-variant-unit-price]');
        if (unitPrice && nextUnitPrice) {
          unitPrice.textContent = nextUnitPrice.textContent;
          unitPrice.hidden = nextUnitPrice.hidden;
        }
        const image = root.querySelector('[data-product-main-image]');
        const nextImage = nextRoot.querySelector('[data-product-main-image]');
        if (image && nextImage) image.replaceChildren(...nextImage.childNodes);
        const id = applyState(nextState);
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.delete('option_values');
        if (id) pageUrl.searchParams.set('variant', id);
        else {
          pageUrl.searchParams.delete('variant');
          pageUrl.searchParams.set('option_values', values);
        }
        window.history.replaceState(window.history.state, '', pageUrl);
      } catch (error) {
        if (error.name === 'AbortError' || currentRequest !== requestNumber) return;
        submit.disabled = true;
        variantInput.disabled = true;
        showStatus(status.dataset.errorLabel, true);
      } finally {
        if (currentRequest === requestNumber) options.removeAttribute('aria-busy');
      }
    });
  };

  document.querySelectorAll('[data-product-root]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-product-root]').forEach(initialise));
})();
